export default class Links {
  constructor() {
    this.smoothScroll = true;
    this.externalBlank = true;
  }

  init() {
    /* eslint-disable no-restricted-globals */
    $('a[href*="#"]', $('body'))
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('[data-toggle=tab]')
      .on('click', (e) => {
        const element = e.currentTarget;

        if (location.pathname.replace(/^\//, '') === element.pathname.replace(/^\//, '') && location.hostname === element.hostname) {
          e.preventDefault();
          const target = $(element.hash);
          this.constructor.smoothScroll(target);
        }
      });

    
    if (location.hash.length) {
      if (this.constructor.isValidId(location.hash)) {
        const target = $(location.hash);
        this.constructor.smoothScroll(target);
      }
    }
    /* eslint-enable no-restricted-globals */
    
    this.openExternalLinksBlank();
    this.constructor.openDownloadsBlank();
  }

  /**
   * Animates the body scrollTop when clicking on a link
   * 
   * @param {*} target 
   * @param int speed 
   * @param int offset 
   * @param bool mindHeader 
   */
  static smoothScroll(target, speed = 300, offset = 0, mindHeader = true, callback = null) {
    let offsetScroll = offset;

    if (mindHeader) {
      const header = $('.header');
      if (header.css('position') === 'fixed' || header.css('position') === 'sticky') {
        offsetScroll += header.height();
      }
    }

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - offsetScroll,
      }, speed, () => {
        window.history.pushState({}, '', target.hash);
        if (callback) {
          callback();
        }
      });
    }
  }

  /**
   * Opens links that aren't in our multisite network in a new tab
   */
  openExternalLinksBlank() {
    if (!this.externalBlank) {
      return;
    }

    $('a')
      .filter('[href^="http"]')
      .not('a[href*="gpgroot"]')
      .each((index, el) => {
        if (el.hostname.length
          && (el.hostname !== window.location.hostname && !siteUrls.indexOf(el.hostname) >= 0)) {
          $(el).attr('target', '_blank');
        }
      });
  }

  static openDownloadsBlank() {
    const filetypes = ['pdf', 'doc', 'docx', 'jpg', 'png', 'xls', 'xlsx'];
    
    filetypes.forEach((extension) => {
      $(`a[href$="${extension}"]`).each((index, el) => {
        $(el).attr('target', '_blank');
      });
    });
  }

  static isValidId(id) {
    return id.indexOf('#.') === -1;
  }
}


$(document).ready(() => {
  new Links().init();
});
